import { render, staticRenderFns } from "./CallCenterSection.vue?vue&type=template&id=25ed7d46&scoped=true&"
import script from "./CallCenterSection.vue?vue&type=script&lang=js&"
export * from "./CallCenterSection.vue?vue&type=script&lang=js&"
import style0 from "./CallCenterSection.vue?vue&type=style&index=0&id=25ed7d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed7d46",
  null
  
)

export default component.exports